<template>
  <div>

    <el-steps variant="info" :active="activeStep" finish-status="info">
      <el-step title="Completar información"></el-step>
      <el-step title="Revisar y confirmar"></el-step>
    </el-steps>

    <!-- Completar información -->
    <b-form v-if="activeStep === 0" data-vv-scope="unify-components">
      <b-row>

        <!-- Seleccionar componentes a unificar -->
        <b-col md="7">
          <b-form-group>
            <label for="unify_components_ids">Seleccionar componentes a unificar <span
                class="text-danger">*</span></label>
            <el-select id="unify_components_ids" name="unify_components_ids"
              v-model="currentUnifyComponent.unify_components_ids" placeholder="Seleccionar componentes a unificar"
              filterable remote clearable multiple reserve-keyword collapse-tags
              no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
              :remote-method="searchComponentRemote">
              <el-option v-for="component in getComponentsCas" :key="component.name + component.id"
                :label="component.name" :value="component.id">
              </el-option>
            </el-select>
            <span class="text-danger small" v-text="errors.first('unify-components.unify_components_ids')" />
          </b-form-group>
        </b-col>

        <b-col md="1"></b-col>

        <!-- Seleccionar un componente de destino -->
        <b-col md="4">
          <b-form-group>
            <label for="prod_component_id">Seleccionar un componente de destino <span
                class="text-danger">*</span></label>
            <el-select id="prod_component_id" name="prod_component_id" v-model="currentUnifyComponent.prod_component_id"
              filterable remote clearable reserve-keyword placeholder="Seleccionar componente de destino" collapse-tags
              no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
              :remote-method="searchPrimaryComponentRemote" data-vv-as=" "
              @change="onHandleSelectedDestinationComponent">
              <el-option v-for="(component, index) in componentsToPrimaries" :key="index" :label="component.name"
                :value="component.id">
              </el-option>
            </el-select>
            <span class="text-danger small" v-text="errors.first('unify-components.tipo_peligro')" />
          </b-form-group>
        </b-col>

      </b-row>

      <b-row class="max-height-details-components-vs">

        <!-- componentes a unificar -->
        <b-col md="7">
          <b-list-group class="h-100" v-if="getComponentsToUnify().length > 0">
            <b-list-group-item v-for="component in getComponentsToUnify()" :key="component.id"
              class="d-flex align-items-center justify-content-between h-100 p-2">
              <div>
                <b-avatar variant="danger" class="mr-2" size="sm" :text="component.icon"></b-avatar>
                <span class="mr-auto">
                  <strong>{{ component.cas }}</strong>
                  {{ component.name }}
                </span>
              </div>
              <b-button variant="light" @click="() => onHandleClearSelectedComponent(component.id)" class="ml-2">
                <i class="fa fa-trash"></i>
              </b-button>
            </b-list-group-item>
          </b-list-group>
          <b-list-group class="h-100" v-else>
            <b-list-group-item class="d-flex justify-content-center align-items-center h-100">
              <span class="text-dark">
                <i class="fa fa-info-circle"></i>
                No hay componentes seleccionados aún.
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col md="1" class="d-flex justify-content-center align-items-center">
          <h3><b-badge variant="danger">{{ getComponentsToUnify().length }}</b-badge></h3>
          <i class="fa fa-arrow-right mx-2 text-gray pb-1"></i>
          <h1><b-badge variant="primary">{{ getComponentPrimary() ? 1 : 0 }}</b-badge></h1>
        </b-col>

        <!-- componente de destino -->
        <b-col md="4">
          <b-list-group class="h-100">
            <b-list-group-item class="d-flex justify-content-center align-items-center h-100">
              <div class="text-center" v-if="getComponentPrimary()">
                <b-avatar variant="primary">{{ formatWordToConvertToIcon(getComponentPrimary().name) }}</b-avatar>
                <div class="mt-2">
                  <span class="mr-auto text-primary">
                    <strong>{{ getComponentPrimary().cas }}</strong>
                    {{ getComponentPrimary().name }}
                  </span>
                </div>
              </div>
              <div class="text-center" v-else>
                <span class="mr-auto text-primary">No hay componente de destino aún.</span>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>

      </b-row>

      <hr class="mt-4" />
      <div class="d-flex align-items-center justify-content-between">
        <b-button type="button" variant="light" class="ml-2" @click="onHandleCancelProcess">
          <i class="fa fa-close mr-1"></i>
          <span class="ml-1" v-text="'Cancelar'"></span>
        </b-button>
        <b-button @click="nextStep"
          :disabled="!getComponentsToUnify() || typeof getComponentsToUnify() !== 'object' || getComponentsToUnify().length <= 0 || !getComponentPrimary()"
          variant="light">
          Revisar y confirmar
          <i class="fa fa-arrow-right ml-1"></i>
        </b-button>
      </div>

    </b-form>

    <!-- Revisar y confirmar -->
    <b-row v-if="activeStep === 1">

      <!-- Detalles de información -->
      <div class="p-3 w-100">

        <!-- Detalles de información - Lista de componentes seleccionados -->
        <b-col md="12" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="bg-degrade-light">
              <div class="d-flex align-items-start justify-content-between mb-2">
                <strong class="text-dark">Lista
                  de componentes seleccionados</strong>
                <h1 class="m-0"><b-badge class="mr-1 text-white" variant="dark">{{ getComponentsToUnify().length
                    }}</b-badge></h1>
              </div>
              <b-list-group-item
                class="border-0 p-1 text-gray items-components d-flex align-items-center justify-content-start"
                v-for="(component, index) in getComponentsToUnify()" :key="component.id">
                <b-badge class="mr-1 text-white mr-2" variant="dark">{{ index + 1 }}</b-badge>
                <p class="m-0">
                  <strong class="mr-1">{{ component.cas }}</strong>{{ component.name }}
                </p>
              </b-list-group-item>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- Detalles de información - Componente de destino -->
        <b-col md="12" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="bg-degrade-info">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fa fa-check"></i>
                  <div class="ml-2">
                    <strong class="text-dark">Componente de destino</strong>
                    <br />
                    <p class="mb-0 mt-2" v-if="getComponentPrimary()">
                      <strong>{{ getComponentPrimary().cas }}</strong>
                      {{ getComponentPrimary().name }}
                    </p>
                  </div>
                </div>
                <h1 class="m-0"><b-badge class="mr-1 text-white" variant="primary">1</b-badge></h1>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- Detalles de información - Cantidad de productos químicos que se verán afectados -->
        <b-col md="12" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="bg-degrade-danger">
              <div class="mt-2 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fa fa-warning"></i>
                  <h6 class="m-0 ml-2"><strong> {{ getQuantityAffectedProducts().length }} Productos químicos se verán afectados</strong></h6>
                </div>
                <div class="d-flex align-items-center">
                  <b-button variant="danger" @click="() => visibleDataAffectedProducts = !visibleDataAffectedProducts"
                    class="mr-1">
                    {{ visibleDataAffectedProducts ? 'Ocultar' : 'Ver' }} detalles
                    <i class="fa ml-2" :class="visibleDataAffectedProducts ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </b-button>
                </div>
              </div>

              <div class="mt-2 bg-white" v-show="visibleDataAffectedProducts">

                <div class="d-flex align-items-center justify-content-start">
                  <h4><b-badge variant="light" class="p-2"><i class="fa fa-info-circle"></i> {{ getQuantityAffectedProducts().length }} productos serán afectados</b-badge></h4>
                  <h4 class="ml-2"><b-badge class="p-2" variant="warning"><i class="fa fa-warning"></i> {{ getProductsThatRequireAttention.length }} productos requieren atención</b-badge></h4>                
                </div>
                
                <b-table thead-tr-class="table-light" small hover :fields="tableAffectedProducts.fields" :items="getQuantityAffectedProducts()">

                  <template #cell(product)="data"><span class="text-gray">{{ data.item.group.name }}</span></template>
                  <template #cell(manufacturer)="data">
                    <span class="text-gray">{{ data.item.group.manufacturer }}</span>
                  </template>
                  <template #cell(components)="data">
                    <h5 class="m-0">
                      <i 
                        v-if="!data.item.components.some(x => x.cas == getComponentPrimary().cas_number) && data.item.components.length > 1" 
                        class="fa mr-2"
                        :class="data.item.components.find(c => currentUnifyComponent.new_components.find(nc => 
                          (nc.prod_product_id == data.item.group.id && nc.prod_component_id == c.prod_component_id)
                        )) ? 'fa-check text-primary' : 'fa-exclamation-triangle text-warning'"
                      ></i>
                      <b-badge variant="light">{{ data.item.components.some(x => x.cas == getComponentPrimary().cas_number) ? (data.item.components.length-1) : data.item.components.length }}</b-badge>
                    </h5>
                  </template>
                  <template #cell(show_details)="data">
                    <b-button size="sm" @click="data.toggleDetails" class="mr-2" variant="light">
                      <i class="fa fa-edit"></i>
                      {{ data.detailsShowing ? 'Ocultar' : 'Ver' }} detalles
                    </b-button>
                  </template>

                  <template #row-details="data">
                    <b-card>

                      <!-- Si no tiene al componente principal y la cantidad de componentes es mayor a 1 -->
                      <div
                        v-if="!data.item.components.some(x => x.cas == getComponentPrimary().cas_number) && data.item.components.length > 1">
                        
                        <div class="mt-1">
                          <CreateComponent :components="data.item.components" :destineComponent="getComponentPrimary()" />
                        </div>
                      </div>

                      <!-- Detalles básicos de los componentes -->
                      <div v-else>

                        <b-row>
                          <!-- Detalles de componentes -->
                          <b-col sm="12" md="5">
                            <h5><b-badge variant="danger"><i class="fa fa-close"></i> Componentes unificados</b-badge></h5>
                            <b-list-group v-for="(component) in data.item.components" :key="component.id">
                          
                              <!-- Componentes que inactiva -->
                              <div v-if="getComponentPrimary().cas_number != component.cas">
                                <b-list-group-item class="mb-1 p-1 d-flex justify-content-start align-items-center">
                                  <strong class="ml-2">{{ component.cas_number || component.cas }}</strong> 
                                  <span class="ml-2">{{ component.name }}</span>
                                </b-list-group-item>
                              </div>
                              
                            </b-list-group>
                          </b-col>

                          <b-col m="12" md="2" class="d-flex justify-content-center align-items-center">
                            <h3><b-badge variant="danger">{{ data.item.components.some(x => x.cas == getComponentPrimary().cas_number) ? (data.item.components.length-1) : data.item.components.length }}</b-badge></h3>
                            <i class="fa fa-arrow-right mx-2 text-gray pb-1"></i>
                            <h1><b-badge variant="primary">1</b-badge></h1>
                          </b-col>

                          <!-- Componente de destino existente en el listado del producto -->
                          <b-col sm="12" md="5" >
                            <div >
                              <h5><b-badge variant="primary"><i class="fa fa-check"></i> Componente de destino</b-badge></h5>
                              <b-list-group-item class="mb-1 p-1 d-flex justify-content-start align-items-center">
                                  <strong class="ml-2">{{ getComponentPrimary().cas }}</strong> 
                                  <span class="ml-2">{{ getComponentPrimary().name }}</span>
                              </b-list-group-item>
                            </div>
                          </b-col>
                        </b-row>
                      </div>

                    </b-card>
                  </template>

                </b-table>

              </div>

            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- Detalles de información - Cantidad de peligros que se verán afectados -->
        <b-col md="12" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="bg-degrade-danger">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="fa fa-warning"></i>
                  <div class="ml-2">
                    <strong>Peligros</strong>
                    <br />
                    <span class="mt-1 text-left">
                      Peligros que serán afectados.
                    </span>
                  </div>
                </div>
                <h1 class="m-0"><b-badge class="mr-1 text-white" variant="danger">{{ getQuantityAffectedDanger
                    }}</b-badge></h1>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>

      </div>

      <!-- Botones de finalización -->
      <hr class="mt-4" />
      <b-col md="12" sm="12">
        <div class="w-100 d-flex align-items-center justify-content-between">

          <b-button variant="light" @click="backStep">
            <i class="fa fa-arrow-left mr-1"></i>
            Regresar
          </b-button>
          <b-button type="button" variant="outline-primary" class="ml-2" @click="onHandleStoreUnifyComponents">
            <span class="ml-1" v-text="'Finalizar y crear unificación'"></span>
            <i class="fa fa-arrow-right ml-2"></i>
          </b-button>

        </div>
      </b-col>

    </b-row>

  </div>
</template>

<script>

// Generales
import { mapActions, mapMutations, mapState } from "vuex";

// Componentes
import CreateComponent from './fragments/CreateComponent.vue'

export default {

  name: "unifyComponentsFormManage",

  components: {
    CreateComponent
  },

  props: {
    closeModal: {
      type: Function,
      required: true,
    }
  },

  data() {
    return {
      activeStep: 0,
      visibleDataAffectedProducts: false,
      tableAffectedProducts: {
        fields: [
          {
            key: 'product',
            label: 'Producto',
            sortable: false
          },
          {
            key: 'manufacturer',
            label: 'Fabricante',
            sortable: false
          },
          {
            key: 'components',
            label: 'Componentes',
            sortable: false
          },
          {
            key: 'show_details',
            label: 'Acciones',
            sortable: false
          }
        ]
      },
      allComponentsDataTemporary: []
    };
  },

  watch: {
    'componentsCas'(next) {
      if (next && typeof next === 'object' && 'data' in next) next.data.map(x => this.allComponentsDataTemporary.push(x));
    }
  },

  mounted() {
    this.setComponentsNewCas();
  },

  computed: {

    ...mapState('nuevocas', {
      componentsCas: 'todosLoscomponentes'
    }),

    ...mapState('unifyComponents', [
      'action',
      'tableConfig',
      'currentUnifyComponent',
      'componentsToPrimaries'
    ]),

    getComponentsCas() {
      if (!this.componentsCas || !('data' in this.componentsCas) || typeof this.componentsCas.cas === 'object') return []

      return this.componentsCas.data
    },

    /**
     * Peligros afectados.
     */
    getQuantityAffectedDanger() {
      try {

        const dangers = this.currentUnifyComponent.affected_dangers
        if (!dangers || typeof dangers !== 'number') return 0

        return this.currentUnifyComponent.affected_dangers

      } catch (e) {
        return 0;
      }
    },

    getProductsThatRequireAttention() {
      
      let products = [];
      this.getQuantityAffectedProducts().map(productComponent => {
        if (!productComponent.components.some(x => x.cas == this.getComponentPrimary().cas_number) && productComponent.components.length > 1) {
          products.push(productComponent)
        }
      })

      return products;
    }

  },

  methods: {

    ...mapMutations('nuevocas', {
      setFilterSearchComponents: 'setFiltroBuscadorComponente',
      setComponentsNewCas: 'establecerTodosComponentes'
    }),

    ...mapMutations('unifyComponents', {
      setCurrentUnifyComponent: 'setCurrentUnifyComponent',
      resetCurrentUnifyComponent: 'resetCurrentUnifyComponent'
    }),

    ...mapActions('nuevocas', {
      getComponents: 'listarComponentes'
    }),

    ...mapActions('unifyComponents', {
      storeUnifyComponents: 'store',
      searchComponentsPrimaries: 'searchComponentsPrimaries',
      getAllUnifyComponents: 'getAll',
      getProductsAssignedToComponentsIds: 'getProductsAssignedToComponentsIds'
    }),

    onHandleSelectedDestinationComponent(componentDestinationId) {

      const exist = this.currentUnifyComponent.unify_components_ids.find(x => x === componentDestinationId)
      if (exist) {
        this.setCurrentUnifyComponent({
          ...this.currentUnifyComponent,
          prod_component_id: null
        });
        this.$alertError("¡El componente de destino no puede estar entre los componentes a unificar!", 10000, true, "Unificación de componentes", 'info');
      }

      else {
        this.setCurrentUnifyComponent({
          ...this.currentUnifyComponent,
          prod_component_id: componentDestinationId
        });
      }
    },

    onHandleClearSelectedComponent(componentId) {
      this.setCurrentUnifyComponent({
        ...this.currentUnifyComponent,
        unify_components_ids: this.currentUnifyComponent.unify_components_ids.filter(x => x !== componentId)
      });
    },

    /**
     * Procesar los componentes a unificar.
     */
    getComponentsToUnify() {
      try {
        const componentsUnifies = [];

        if (!this.currentUnifyComponent.unify_components_ids || typeof this.currentUnifyComponent.unify_components_ids !== 'object' || !this.allComponentsDataTemporary || typeof this.allComponentsDataTemporary !== 'object') return [];

        this.currentUnifyComponent.unify_components_ids.map(componentUnify => {
          const findComponent = this.allComponentsDataTemporary.find(component => component.id === componentUnify);
          if (findComponent) {
            componentsUnifies.push({
              id: findComponent.id,
              name: findComponent.name,
              icon: this.formatWordToConvertToIcon(findComponent.name),
              cas: findComponent.cas_number
            })
          }
        })

        return componentsUnifies
      } catch (e) {
        return []
      }
    },

    /**
     * Procesar el componente de destino.
     */
    getComponentPrimary() {

      if (!this.componentsToPrimaries || typeof this.componentsToPrimaries !== 'object') {
        return null;
      }

      const item = this.componentsToPrimaries.find(x => x.id === this.currentUnifyComponent.prod_component_id);

      return item ? {
        id: item.id,
        name: item.name,
        icon: this.formatWordToConvertToIcon(item.name),
        cas: item.cas_number
      } : null
    },

    /**
     * Productos afectados.
     */
    getQuantityAffectedProducts() {
      try {

        const componentsToUnify = this.getComponentsToUnify()
        const componentPrimary = this.getComponentPrimary()

        const products = this.currentUnifyComponent.affected_products
        if (!products || typeof products !== 'object') return 0

        const productsData = []
        Object.values(products).forEach(items => {

          let product = items[0].prod_product
          let componentsAll = items.map(component => {

            let componentFind = componentsToUnify.find(componentUnify => componentUnify.id === component.prod_component_id)
            if (componentFind) {
              return {
                ...component,
                "id": component.id,
                "name": componentFind.name,
                "icon": componentFind.icon,
                "cas": componentFind.cas
              }
            }

            if (componentPrimary.id == component.prod_component_id) {
              return {
                ...component,
                "id": component.id,
                "name": componentPrimary.name,
                "icon": componentPrimary.icon,
                "cas": componentPrimary.cas
              }
            }

          })

          if ('prod_component_products' in product && typeof product.prod_component_products === 'object' && product.prod_component_products.length > 0) {
            componentsAll.push(product.prod_component_products[0])
          }

          productsData.push({
            group: {
              id: product.id,
              name: product.nombre,
              manufacturer: ('fabricante' in product && product.fabricante) ? product.fabricante.nombre : 'No registra fabricante',
            },
            components: componentsAll
          });

        })

        return productsData;

      } catch (e) {
        return [];
      }
    },

    /**
     * Formatear texto para convertir a icono de 3 letras.
     */
    formatWordToConvertToIcon(word) {
      if (typeof word !== 'string') return "COM";

      return word.trim().split(' ').slice(0, 3).map(x => x.charAt(0).toUpperCase()).join('')
    },

    /**
     * Buscar componentes para selección multiple.
     * 
     * @param param 
     */
    async searchComponentRemote(param) {
      this.setFilterSearchComponents({ buscar: param, page: 1, active: 1 })
      await this.getComponents();
    },

    /**
     * Buscar componentes para selección única.
     * 
     * @param param 
     */
    async searchPrimaryComponentRemote(param) {
      const payload = {
        buscar: param,
        cas_family: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "desc",
        active: 1
      }
      await this.searchComponentsPrimaries(payload);
    },

    /**
     * Ir al siguiente paso.
     */
    async nextStep() {
      if (this.activeStep === 0) {
        const prodComponentsIds = this.getComponentsToUnify().map(x => x.id)
        if (!prodComponentsIds || prodComponentsIds.length <= 0) return false

        const data = {
          prodComponentsIds,
          ownerComponentId: this.getComponentPrimary().id
        }

        await this.getProductsAssignedToComponentsIds(data);
      }

      this.visibleDataAffectedProducts = false
      this.activeStep = 1
    },

    /**
     * Ir al paso anterior.
     */
    backStep() {
      this.activeStep = 0
    },

    /**
     * Cancelar proceso y cerrar modal.
     */
    onHandleCancelProcess() {
      this.closeModal()
    },

    /**
     * Confirmar crear unificación.
     */
    onHandleStoreUnifyComponents() {

      if (this.currentUnifyComponent.new_components.length < this.getProductsThatRequireAttention.length) {
        this.$alertError(
          `¡No se puede continuar con la acción! ${this.getProductsThatRequireAttention.length - this.currentUnifyComponent.new_components.length} productos requieren atención.`,  
          10000,  true,  'Unificación de componentes',  'info'
        );
        return false;
      }

      this.$alertConfirmation({
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#acacac',
        title: 'UNIFICACIÓN DE COMPONENTES',
        text: '¿Esta seguro que desea continuar con la acción?, Recuerde que este proceso no se puede revertir. Por favor, revise cuidadosamente la información antes de proceder.',
        onConfirm: this.onHandleConfirm
      });
    },

    /**
     * Crear unificación.
     */
    async onHandleConfirm() {

      const { prod_component_id, unify_components_ids, new_components } = this.currentUnifyComponent

      const response = await this.storeUnifyComponents({ prod_component_id, unify_components_ids, new_components });
      if (!response) return false;

      this.closeModal();

      let currentPage = 1;
      if (this.tableConfig && 'items' in this.tableConfig.items && this.tableConfig.items && 'current_page' in this.tableConfig.items) {
        currentPage = this.tableConfig.items.current_page
      }
      await this.getAllUnifyComponents(currentPage, this.tableConfig.items.per_page);
    },

  }

};
</script>

<style scoped>
.max-height-details-components-vs {
  max-height: 320pt;
  overflow-y: auto;
}

.text-gray {
  color: rgb(94, 93, 93);
}

.items-components {
  padding: 6px 0 !important;
  border-radius: 5px;
  margin-top: 6px;
  background-color: transparent;
}

</style>
